import { useChatHistory } from '@packages/chat/react';
import { useId } from 'react';
import { candidatesApi } from '../candidatesApi';
import type {
  CandidateProcess,
  CandidateProcessListResponse,
  CandidateProcessRequestParams,
} from '../../types';
import { candidateQueryKeys } from '../queryKeys';

export const useGetCandidateProcesses = (
  id: string,
  params: CandidateProcessRequestParams,
  pollInterval: number | false = 10_000
) => {
  const sessionId = useId();
  const history = useChatHistory<
    CandidateProcess,
    CandidateProcessListResponse
  >({
    sessionId,
    queryKeys: {
      latest: candidateQueryKeys.processesRefresh(id, params, sessionId),
      history: candidateQueryKeys.processes(id, params, sessionId),
    },
    enabled: Boolean(id),
    pollInterval,
    fetchPage: (page, signal) =>
      candidatesApi.getCandidateProcesses(
        id,
        { filter: params.filter, page },
        signal
      ),
  });

  return { ...history, sessionId };
};

export type CandidateProcessesHistory = ReturnType<
  typeof useGetCandidateProcesses
>;
